import AdultSymptomExercisePage from "@/components/AdultSymptomExercisePage";
import { isAdultExerciseGroup } from "@/lib/data/contentCatalog";
import { createFileRoute } from "@tanstack/react-router";
import ExerciseImage from "@/assets/exercise-background-photos/guilt-feelings.jpg";
import guiltFeelingsWebm from "@/assets/videos/adults-symptoms/guilt-feelings/guilt-feelings.webm";
import guiltFeelingsMp4 from "@/assets/videos/adults-symptoms/guilt-feelings/guilt-feelings.mp4";
import guiltPoster from "@/assets/guilt-feelings-poster.png";
import guiltEn from "/subs/guilt-feelings.en.vtt";
import guiltAr from "/subs/guilt-feelings.ar.vtt";
import { useLocaleStore } from "@/lib/stores/localeStore";

export const Route = createFileRoute(
  "/(content)/adults/exercises/guilt-feelings/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Guilt Feelings - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "exercises.categories.guiltFeelings",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();

  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: "ltr" | "rtl" = locale === "ar" ? "rtl" : "ltr";
  const videos = [
    {
      sources: [
        { src: guiltFeelingsWebm, type: "video/webm" },
        { src: guiltFeelingsMp4, type: "video/mp4" },
      ],
      subtitleTracks: [
        { src: guiltAr, srcLang: "ar", label: "Arabic", default: true },
        { src: guiltEn, srcLang: "en", label: "English" },
      ],
      activeSubtitleLanguage: locale === "ar" ? "ar" : "en",
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="guilt-feelings"
      titleKey="exercises.categories.guiltFeelings"
      heroImage={ExerciseImage}
      poster={guiltPoster}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
    />
  );
}
